import { REDUX_MODEL_KEY } from '../../../../redux/constants/key'
import getDataValueReduxUtil from '../../../../redux/utils/get-data-value'
import isNewReduxUtil from '../../../../redux/utils/is-new'
import { createISOStrDateUtil } from 'packages/src'
import setUtil from '../../../../../utils/set'

/**
 * Merges the given `newInstance` inside the `instance`,
 * by only setting the `newInstance` data that was updated.
 * @param  {Instance} instance
 * @param  {Instance} newInstance
 * @return {Instance}
 */
export default function mergeInstances (instance, newInstance) {
  const changed = {
    ...isNewReduxUtil(instance)
      ? {}
      : instance.changed,
    ...newInstance.changed
  }

  const newKeys = Object.keys(newInstance.data)
  newKeys.forEach(key => {
    const changedValue = changed[key]
    const dataValue = getDataValueReduxUtil(instance, key)
    const value = newInstance?.data?.[key]
    if (value !== dataValue) {
      instance = setUtil(instance, `${REDUX_MODEL_KEY.DATA}.${key}`, value)
    } else if (changedValue === dataValue) {
      delete changed[key]
    }
  })

  const mergedInstance = {
    ...instance,
    status: newInstance.status,
    changed,
    updatedAt: createISOStrDateUtil(),
    error: null,
    validation: null
  }
  return mergedInstance
}
